<template>
  <div v-if="!isFrame" class="bg-gray-700 bottom-[0px] tab-nav w-full">
    <div class="container max-w-[800px] mr-auto">
      <div class="flex">
        <router-link
          v-for="tab in tabs"
          :key="tab.id"
          :to="tab.link"
          @click="selectTab(tab.id)"
          class="px-8 py-2 flex flex-col gap-1 w-full items-center text-gray-100 transition-colors duration-200 relative"
          :class="{
            'text-blue-400': activeTab === tab.id,
            'hover:text-blue-300': activeTab !== tab.id
          }"
        >
          <div v-if="activeTab === tab.id" class="flex gap-1 flex-col items-center">
            <img class="h-5" :src="tab.icon" alt="" />
            <span class="text-[12px] font-semibold">{{ tab.name }}</span>
          </div>
          <div v-else class="opacity-50 flex gap-1 flex-col items-center">
            <img class="h-5" :src="tab.icon" alt="" />
            <span class="text-[12px]">{{ tab.name }}</span>
          </div>
        </router-link>

      </div>
    </div>
  </div>
  <div v-else class="bg-gray-700 bottom-[0px] tab-nav w-full">
    <div class="container max-w-[800px] mr-auto">
      <div class="flex">
        <router-link
          v-for="tab in tabs"
          :key="tab.id"
          :to="'/frame'+tab.link"
          @click="selectTab(tab.id)"
          class="px-8 py-2 flex flex-col gap-1 w-full items-center text-gray-100 transition-colors duration-200 relative"
          :class="{
            'text-blue-400': activeTab === tab.id,
            'hover:text-blue-300': activeTab !== tab.id
          }"
        >
          <div v-if="activeTab === tab.id" class="flex gap-1 flex-col items-center">
            <img class="h-5" :src="tab.icon" alt="" />
            <span class="text-[12px] font-semibold">{{ tab.name }}</span>
          </div>
          <div v-else class="opacity-50 flex gap-1 flex-col items-center">
            <img class="h-5" :src="tab.icon" alt="" />
            <span class="text-[12px]">{{ tab.name }}</span>
          </div>
        </router-link>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { defineEmits } from 'vue';

const emit = defineEmits(['tab-change']);
const isFrame = window.location.pathname.includes("frame")
const tabs = [
  { id: 'forecasts', name: 'Forecasts', link: '/', icon: "https://img.icons8.com/?size=100&id=58&format=png&color=ffffff" },
  { id: 'results', name: 'Results', link: '/results', icon: "https://img.icons8.com/?size=100&id=25218&format=png&color=ffffff" }
];

const route = useRoute();

// Определяем активную вкладку на основе текущего URL
const activeTab = computed(() => {
  // Если путь начинается с '/results', то активна вкладка 'results'
  return route.path.endsWith('/results') ? 'results' : 'forecasts';
});

function selectTab(tabId) {
  emit('tab-change', tabId);
}
</script>

<style>
.tab-nav {
  z-index: 1000;
  position: fixed;
  bottom: 0;
}
</style>
